import { IconLargeMissedEvent } from '@byted-tiktok/tux-icons';
import useConfig from 'packages/common/hooks/useConfig';
import { emitCounter } from 'packages/common/slardar';
import React, { FC, useEffect } from 'react';
import Status from './Status';
type ErrorPageProps = {
  darkMode?: boolean;
  errText?: string;
  page?: string;
};
export const ErrorPage10019: FC<ErrorPageProps> = props => {
  const {
    t
  } = useConfig();
  const {
    darkMode,
    errText,
    page
  } = props;
  useEffect(() => {
    emitCounter('participate-another-activity', 1);
  }, []);
  return <Status icon={<IconLargeMissedEvent className={`text-color-${darkMode ? 'ConstTextInverse4' : 'TextQuaternary'}`} style={{
    fontSize: 56
  }} />} title={t('participate_another_activity_title', "Rewards activity isn't available")} subtitle={t('participate_another_activity_subtitle', "You've participated in another rewards activity on TikTok.")} darkMode={darkMode} errText={errText} page={page} />;
};